// Dependencies
import React from 'react';

// Components
import Top from './top';
import Bottom from './bottom';

// Styles
import FooterStyles from './footer.styles';

export default function Footer() {
  return (
    <FooterStyles>
      <Top />
      <Bottom />
    </FooterStyles>
  );
}
